// Protected surface: review docs/protected-surfaces/admin-surfaces.md before changing admin gating or non-admin redirect behavior.
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useUser } from './contexts/userContext';
import LoadingScreen from './LoadingScreen';
import { isAdminUser } from './utils/adminAccess';

const AdminRoute = ({ children }) => {
    const { user, isLoading } = useUser();
    const location = useLocation();
    
    console.log('[AdminRoute] User state:', user);
    console.log('[AdminRoute] Loading state:', isLoading);

    if (isLoading) {
        console.log('[AdminRoute] Still loading, showing LoadingScreen');
        return <LoadingScreen />;
    }

    if (!user) {
        console.log('[AdminRoute] No user found, redirecting to login');
        return <Navigate to="/login" replace />;
    }

    // Check if user is admin (either role === 'admin' or is_staff === true)
    const isAdmin = isAdminUser(user);
    
    if (!isAdmin) {
        console.log('[AdminRoute] User is not admin (role:', user.role, ', is_staff:', user.is_staff, '), redirecting to app');
        const cameFromJourneyGuide = Boolean(
            location.pathname.startsWith('/app')
            && (
                location.state?.fromJourneyGuide
                || location.state?.missionId
                || location.state?.activeMissionId
                || location.state?.missionRoute
            )
        );

        if (cameFromJourneyGuide) {
            return (
                <Navigate
                    to="/app/journey-guide"
                    replace
                    state={{
                        navFailure: {
                            reason: 'admin_required',
                            blockedRoute: location.pathname,
                            blockedBy: 'AdminRoute',
                            missionSessionId: location.state?.missionId || location.state?.activeMissionId || null
                        },
                        missionReturnTs: Date.now()
                    }}
                />
            );
        }

        return <Navigate to="/app" replace />;
    }

    console.log('[AdminRoute] User is admin, rendering admin page');
    return children;
};

export default AdminRoute; 
